import React from "react";
import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip
} from "@material-ui/core";
import moment from "moment";
import MonthSlider from "../Slider/MonthSlider";
import { getDate, standardDateFormat } from "../../../utils/helper";
import QTRSlider from "../Slider/QTRSlider";
import DatePickerFromAndTo from "../DatePicker/DatePickerFromAndTo";

class SliderDatePicker extends React.Component {
  constructor(props) {
    super(props);
    
    const {isReporting,isViewReport,sliderType, isAll, showOnly, handelDateChangesSlideDate} = this.props;
    const radioValue =
      isReporting === true &&
      isViewReport !== true &&
      sliderType === 1
        ? "NONE"
        : isReporting === true &&
          isViewReport !== true &&
          sliderType === 4
        ? "TD"
        : isReporting === true &&
          isViewReport !== true &&
          sliderType === 2
        ? "MTD"
        : isReporting === true &&
        isViewReport !== true &&
        sliderType === 3
         ? "MTD"
        : isReporting !== true && isAll === true
        ? "MTD"
        : localStorage.getItem("DateRadioSelect") != null &&
          showOnly === "staffing"
        ? "MTD"
        : localStorage.getItem("DateRadioSelect") != null &&
          localStorage.getItem("DateRadioSelect") === "NONE" &&
          isReporting === true &&
          isViewReport === true &&
          sliderType === 1
        ? localStorage.getItem("DateRadioSelect")
        : localStorage.getItem("DateRadioSelect") != null &&
          localStorage.getItem("DateRadioSelect") !== "NONE" &&
          isReporting === true &&
          isViewReport === true &&
          sliderType === 2
        ? localStorage.getItem("DateRadioSelect")
        : localStorage.getItem("DateRadioSelect") != null &&
          localStorage.getItem("DateRadioSelect") !== "NONE"
        ? localStorage.getItem("DateRadioSelect")
        : "MTD";
    localStorage.setItem("DateRadioSelect", radioValue);
    const{selectedStartDate,selectedEndDate,radioSlider,selectedDate,title} = this.props;
    this.state = {
      RadioSelect: radioValue,
      startDate: selectedStartDate
        ? moment(selectedStartDate).format(standardDateFormat)
        : sliderType === 4
        ? moment().format(standardDateFormat)
        : moment()
            .startOf()
            .format(standardDateFormat),
      endDate: selectedEndDate
        ? moment(selectedEndDate).format(standardDateFormat)
        : sliderType === 4
        ? moment().format(standardDateFormat)
        : moment()
            .endOf()
            .format(standardDateFormat),
      radioSlider: radioSlider, // pass radio array
      selectedDate: selectedDate, // pass selected date
      clearFilterData: props.clearFilterData,
      header: title,
      updateMTD: false,
      updateYTD: false
    };
    if (radioValue === "TD") {
      handelDateChangesSlideDate(
        moment().format(standardDateFormat),
        moment().format(standardDateFormat),
        radioValue
      );
    } else if (radioValue === "WE") {
      handelDateChangesSlideDate(
        moment()
          .add(-6, "day")
          .format(standardDateFormat),
        moment().format(standardDateFormat),
        radioValue
      );
    }
  }

  /** get values from props and set to state. */
  static getDerivedStateFromProps(newProps, state) {
    const radioValue = localStorage.getItem("DateRadioSelect");
    if (
      newProps.clearFilterData !== state.clearFilterData ||
      newProps.selectedDate !== state.selectedDate ||
      state.RadioSelect !== radioValue
    ) {
      let finalReturnObj = null;
      if (newProps.clearFilterData !== state.clearFilterData) {
        finalReturnObj = {
          clearFilterData: newProps.clearFilterData
        };
      }
      if (state.RadioSelect !== radioValue) {
        if (finalReturnObj !== null) {
          finalReturnObj.RadioSelect = radioValue;
        } else {
          finalReturnObj = {
            RadioSelect: radioValue
          };
        }
      }

      if (newProps.selectedDate !== state.selectedDate) {
        if (finalReturnObj !== null) {
          finalReturnObj.selectedDate =
            newProps.selectedDate !== state.selectedDate
              ? newProps.selectedDate
              : state.selectedDate;
        } else {
          finalReturnObj = {
            selectedDate:
              newProps.selectedDate !== state.selectedDate
                ? newProps.selectedDate
                : state.selectedDate
          };
        }
      }

      return finalReturnObj;
    } else {
      return state;
    }
  }

  /** call when date selected if radio value is Date range */
  onDateRange = (GetStatDate, GetEndDate) => {
    const{handelDateChangesSlideDate} = this.props;
    const { RadioSelect } = this.state;
    this.setState({
      startDate: GetStatDate != "Invalid date"? GetStatDate : null,
      endDate: GetEndDate != "Invalid date" ? GetEndDate : null
    });
    handelDateChangesSlideDate((GetStatDate != "Invalid date" ? GetStatDate : null), (GetEndDate != "Invalid date" ? GetEndDate : null), RadioSelect);
  };

  /** set radio value in local storage and state value and call date set method when radio value is Date range */
  onRadioChange = value => {
    localStorage.setItem("DateRadioSelect", value);

    this.setState(
      {
        RadioSelect: value,
        updateMTD: value === "MTD",
        updateYTD: value === "YTD",
      },
      () => {
        const{handelDateChangesSlideDate}= this.props;
        const{startDate,endDate} =this.state;
        if (value == "CDR") {
          handelDateChangesSlideDate(
            startDate,
            endDate,
            value
          );
        } else if (value === "NONE") {
          // check none condition to update the start and end date
          handelDateChangesSlideDate("", "", value);
        } else if (value === "TD") {
          handelDateChangesSlideDate(
            moment().format(standardDateFormat),
            moment().format(standardDateFormat),
            value
          );
        } else if (value === "WE") {
          handelDateChangesSlideDate(
            moment()
              .add(-6, "day")
              .format(standardDateFormat),
            moment().format(standardDateFormat),
            value
          );
        }
      }
    );
  };

  /** set selected start date and end date */
  onChangeMonthRange = (startMonth, endMonth) => {
    const { RadioSelect, updateMTD, updateYTD } = this.state; // pass updated radio selection
    const startDate =
      updateMTD && !updateYTD
        ? moment().startOf("month")
        : !updateMTD && updateYTD
        ? moment().startOf("year")
        : moment(getDate(startMonth));
    const endDate =
      updateMTD || updateYTD
        ? moment().endOf("month")
        : moment(getDate(endMonth));
    this.setState({
      updateMTD: false,
      updateYTD: false
    });
    {
      const props =this.props;
      props.handelDateChangesSlideDate(
        startDate.format(standardDateFormat),
        endDate.format(standardDateFormat),
        RadioSelect
      );
    }
  };

  /** Set selected Quarter values */
  onChangeQuarterRange = (startMonth, endMonth, selectedQuarter) => {
    const { RadioSelect, updateMTD, updateYTD } = this.state; // pass updated radio selection
    const startDate =
      updateMTD && !updateYTD
        ? moment().startOf("month")
        : !updateMTD && updateYTD
        ? moment().startOf("year")
        : moment(getDate(startMonth));
    const endDate =
      updateMTD || updateYTD
        ? moment().endOf("month")
        : moment(getDate(endMonth));
    this.setState({
      updateMTD: false,
      updateYTD: false
    });
    {
     const props= this.props;
     props.handelDateChangesSlideDate(
        startDate.format(standardDateFormat),
        endDate.format(standardDateFormat),
        RadioSelect,
        selectedQuarter
      );
    }
  };

  render() {
    const {
      startDate,
      endDate,
      RadioSelect,
      selectedDate,
      radioSlider
    } = this.state;
    const {
      isViewReport,
      selectedStartDate,
      selectedEndDate,
      clearFilterData,
      showOnly,
      onError
    } = this.props;

    const state= this.state;
    return (
      <Grid
        container
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        style={{ justifyContent: "center" }}
        pt={2}
        pb={2}
      >
        <Grid item xs={12} style={{ justifyContent: "center" }}>
          <label
            id={"multiple-checkbox-header-label"}
            // className={disabled ? "disabled-label" : ""}
          >
            <span style={{ fontSize: "15px", fontWeight: "400" }}>
              {state.header}
            </span>
          </label>
          <RadioGroup
            style={{ justifyContent: "center", marginTop: "15px" }}
            key={"sliderRadio"}
            aria-label={"sliderRadio"}
            name={"sliderRadio"}
            value={state.RadioSelect}
            onChange={e => {
              this.onRadioChange(e.target.value);
            }}
            row
            size={"small"}
          >
            {radioSlider.map((x, i) => {
              return (
                showOnly == x.showWhen && (
                  <FormControlLabel
                    value={x.value}
                    key={"FormControlLabel" + i}
                    size={"small"}
                    control={
                      <Radio style={{ width: "25px", height: "25px" }} />
                    }
                    label={<span style={{ fontSize: "12px" }}>{x.label}</span>}
                  />
                )
              );
            })}
          </RadioGroup>
        </Grid>
        &nbsp;&nbsp;
        {RadioSelect == "CDR" && RadioSelect !== "NONE" ? (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            {" "}
            <Tooltip title={"Date Range"} aria-label={"Date Range"}>
              <DatePickerFromAndTo
                key={"dateRangePicker"}
                onDateChange={this.onDateRange}
                startDate={startDate}
                endDate={endDate}
                onError={onError}
                header={this.state.header}
              />
            </Tooltip>
          </div>
        ) : RadioSelect === "QTR" ? (
          <div style={{ width: "100%" }}>
            <QTRSlider
              key={"QTRSliderPicker"}
              onChangeMonthRange={this.onChangeQuarterRange}
              selectedDate={moment(selectedDate).format(standardDateFormat)}
              sliderView={
                radioSlider.find(x => x.value === RadioSelect)?.sliderValue
              }
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              qtrYear={moment(selectedStartDate).format("YYYY")}
              isViewReport={isViewReport}
            />
          </div>
        ) : RadioSelect !== "NONE" && RadioSelect !== "TD" && RadioSelect !== "WE" &&
          radioSlider.find(x => x.value === RadioSelect) !== undefined ? (
          <div style={{ width: "100%" }}>
            <MonthSlider
              key={"MonthSliderPicker"}
              onChangeMonthRange={this.onChangeMonthRange}
              selectedDate={moment(selectedDate).format(standardDateFormat)}
              sliderView={
                radioSlider.find(x => x.value === RadioSelect)?.sliderValue
              }
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              isViewReport={isViewReport}
              allCleared={clearFilterData}
            />
          </div>
        ) : null}
      </Grid>
    );
  }
}
export default SliderDatePicker;
